module.exports = __webpack_public_path__ + "img/bostonma2.57bfdd39.jpg";